import { render, staticRenderFns } from "./Invoice2.vue?vue&type=template&id=4fa76046"
import script from "./Invoice2.vue?vue&type=script&lang=js"
export * from "./Invoice2.vue?vue&type=script&lang=js"
import style0 from "./Invoice2.vue?vue&type=style&index=0&id=4fa76046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports